import React, { useEffect, useState } from "react"
import useServerSort from "../../../helpers/useServerSort"
import { Card, Col, PopoverBody, Row, UncontrolledPopover } from "reactstrap"
import UpdateTable from "../../../components/Common/UpdatedTable"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import action from "../../../assets/icons/action.svg"
import {
  fetchBrand,
  updateBrandStatus,
} from "../../../services/Inventory/inventory"
import EditBrand from "./edit"
import { toastError, toastSuccess } from "../../../helpers/msg_helper"
import InventoryFilter from "../filter"
import { createSelector } from "reselect"
import { useSelector } from "react-redux"

const Brand = () => {
  const companyname = localStorage.getItem('companyname')
  document.title = `Brands${companyname ? ` | ${companyname}` : ''}`;

  const selectLoginState = state => state.Login
  const LoginProperties = createSelector(selectLoginState, login => ({
    loggedUser: login.loggedUser,
  }))

  const { loggedUser } = useSelector(LoginProperties)

  const [page, setPage] = useState("")

  const [brand, setBrand] = useState()
  const [count, setCount] = useState(0)
  const [status, setStatus] = useState("")
  const [search, setSearch] = useState("")
  const [editBrand, setEditBrand] = useState({ modal: false, value: "" })

  const { sortParam, handleServerSort } = useServerSort(() => setPage(1))
  useEffect(() => {
    const fetchData = async () => {
      const response = await fetchBrand({
        params: `${status == "0" || status == "1" ? `&status=${status}` : ""}${
          search ? `&searchText=${search}` : "&searchText"
        }${page ? `&page=${page}` : ""}${sortParam}${`&sizePerPage=16`}`,
      })
      setBrand(response)
    }
    fetchData()
  }, [count, status, search, page, sortParam])

  const handleEdit = item => {
    setEditBrand({ value: item, modal: true })
  }

  const handleStatus = async id => {
    try {
      const response = await updateBrandStatus(id)
      toastSuccess(response?.message)
      setCount(count + 1)
    } catch (err) {
      toastError(err?.message)
    }
  }

  const columns = [
    {
      label: "Description",
      sortKey: "description",
      renderCell: item => (
        <div className="capitalize-letter">{item?.description}</div>
      ),
      sortKey: "description",
    },
    {
      label: "Status",
      renderCell: item => (
        <div>
          <div
            className={`font-13 ${
              item?.status === 1 ? "status-active" : "status-inactive"
            }`}
          >
            {item?.status === 1 ? "Active" : "Inactive"}
          </div>
        </div>
      ),
    },
    {
      label: "Action",
      renderCell: item => (
        <>
          <div>
            <span id={`PopoverLegacy-${item?.id}`}>
              <img src={action} alt="" className="pointer" />
            </span>
          </div>
          <UncontrolledPopover
            placement="bottom"
            target={`PopoverLegacy-${item?.id}`}
            trigger="legacy"
          >
            <PopoverBody>
              {item?.status === 1 &&
                loggedUser?.permission?.some(
                  permissionItem => permissionItem?.name === "brand_edit"
                ) && (
                  <div
                    className="table-popup-content"
                    onClick={() => handleEdit(item)}
                  >
                    Edit
                  </div>
                )}
              <div
                className={`${
                  item?.status === 1 ? "popover-border" : ""
                } table-popup-content`}
                onClick={() => handleStatus(item?.id)}
              >
                {item?.status === 1 ? "Deactivate" : "Activate"}
              </div>
            </PopoverBody>
          </UncontrolledPopover>
        </>
      ),
    },
  ]

  const handlePaginate = page => {
    setPage(page)
  }

  const handleUpdate = () => {
    setCount(count + 1)
    setPage(1)
  }

  const handleResetValue = () => {
    setEditBrand("")
    setPage(1)
  }

  const handleSearchChange = data => {
    setSearch(data)
    setPage(1)
  }
  const handleStatusChange = id => {
    setStatus(id)
    setPage(1)
  }

  return (
    <React.Fragment>
      <div className="page-content tnt-scope">
        <div className="container-fluid">
          <div className="d-flex justify-content-between">
            <Breadcrumbs
              title="Inventory"
              breadcrumbObject={[
                { title: "Product Master", link: "/inventory" },
                { title: "Brand", link: "/inventory-brand" },
              ]}
            />
            {loggedUser?.permission?.some(
              permissionItem => permissionItem?.name === "brand_create"
            ) && (
              <EditBrand
                key={"x"}
                onUpdate={handleUpdate}
                onReset={handleResetValue}
                buttonLabel="+&nbsp; Brand"
                className="px-2 mb-3 me-2 btn btn-primary"
                editItem={editBrand}
              />
            )}
          </div>
          <Card className="me-2 px-2 pb-2 main-dashboard-bg">
            <InventoryFilter
              handleStatusChange={handleStatusChange}
              handleSearchChange={handleSearchChange}
              sampleUrl={"download/brands.xlsx"}
              importUrl={"brands/import"}
              isExport={
                loggedUser?.permission?.some(
                  permissionItem => permissionItem?.name === "brand_create"
                )
                  ? true
                  : false
              }
            />
            <hr className="table-divide" />
            <Row className="mt-2 ever-rise-table">
              <Col xs={12}>
                {brand?.data?.data && (
                  <UpdateTable
                    className="mt-5"
                    nodes={brand?.data?.data}
                    paginate={brand?.data}
                    columns={columns}
                    CurrentPage={page}
                    handlePagination={handlePaginate}
                    handleServerSort={handleServerSort}
                    tableWidth="40% 45% 15%"
                    mobileWidth="40% 45% 15%"
                  />
                )}
              </Col>
            </Row>
          </Card>
        </div>
      </div>
    </React.Fragment>
  )
}

export default Brand
